$(document).ready(function(){
	
	$('.ty-galerie-balken').imagesLoaded( function() {
	  // images have loaded

		//  Owl Carousel
		$('.owl-carousel').owlCarousel({
				    margin:10,
				    loop:false,
				    autoWidth:true,
				    nav:false,
				    dots:true,
				    items:1
		});
	  
	});
		
});

$(document).foundation();
